// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#radialbarchart {
  position: relative;
  left: -1.3vw; /* Move to the left */
}

.pagecontent-circlechart {
  position: relative;
  width: fit-content;
  height: fit-content;
  margin-right: 0px;
}

.pagecontent-circlechart-background {
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  width: fit-content;
  border: 1px solid var(--border);
  background: var(--white-base);
  align-items: center;
  justify-content: center;
}

.pagecontent-circlechart-title {
  display: flex;
  justify-content: center;
  align-items: center;

  /* TEXT FONT */
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
}

.pagecontent-circlechart-innercontainer {
  padding: 10px 0px;
}

.pagecontent-circlechart-dot-IST {
  position: relative;
  border-radius: 50%;
  background-color: var(--indigo);
  width: 8px;
  height: 8px;
  margin-right: 5px;
}

.pagecontent-circlechart-dot-Ziel {
  position: relative;
  border-radius: 50%;
  background-color: var(--lime-green);
  width: 8px;
  height: 8px;
  margin-left: 20px;
  margin-right: 5px;
}

.pagecontent-circlechart-IST {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;

  /* TEXT FONT */
  font-size: 19px;
}

.pagecontent-circlechart-radial-container {
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: 0px;
}

.pagecontent-circlechart-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  /*Text font*/
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/StrategieGesamtunternehmenWidgets.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY,EAAE,qBAAqB;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;;EAEhB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;;EAEnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["#radialbarchart {\r\n  position: relative;\r\n  left: -1.3vw; /* Move to the left */\r\n}\r\n\r\n.pagecontent-circlechart {\r\n  position: relative;\r\n  width: fit-content;\r\n  height: fit-content;\r\n  margin-right: 0px;\r\n}\r\n\r\n.pagecontent-circlechart-background {\r\n  border-radius: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: fit-content;\r\n  border: 1px solid var(--border);\r\n  background: var(--white-base);\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.pagecontent-circlechart-title {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  /* TEXT FONT */\r\n  font-family: Inter;\r\n  font-size: 28px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 36px;\r\n}\r\n\r\n.pagecontent-circlechart-innercontainer {\r\n  padding: 10px 0px;\r\n}\r\n\r\n.pagecontent-circlechart-dot-IST {\r\n  position: relative;\r\n  border-radius: 50%;\r\n  background-color: var(--indigo);\r\n  width: 8px;\r\n  height: 8px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.pagecontent-circlechart-dot-Ziel {\r\n  position: relative;\r\n  border-radius: 50%;\r\n  background-color: var(--lime-green);\r\n  width: 8px;\r\n  height: 8px;\r\n  margin-left: 20px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.pagecontent-circlechart-IST {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n\r\n  /* TEXT FONT */\r\n  font-size: 19px;\r\n}\r\n\r\n.pagecontent-circlechart-radial-container {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-left: auto;\r\n  margin-right: 0px;\r\n}\r\n\r\n.pagecontent-circlechart-info {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  /*Text font*/\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  line-height: 32px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
